<template>
  <div class="drawer">
    <input
      id="my-drawer-3"
      ref="drawerToggle"
      type="checkbox"
      class="drawer-toggle"
    >
    <div class="drawer-content flex flex-col">
      <!-- Navbar -->
      <div
        ref="navbar"
        class="navbar"
      >
        <div class="flex-none lg:hidden">
          <label
            for="my-drawer-3"
            class="btn btn-square btn-ghost"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="inline-block w-6 h-6 stroke-current"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </label>
        </div>
        <div class="flex-1 px-2 mx-2">
          <router-link to="/dashboard">
            <BrandComponent />
          </router-link>
        </div>
        <div class="flex-none hidden lg:block">
          <ul class="menu menu-horizontal">
            <!-- Staff user navigation -->
            <template v-if="isStaff">
              <li>
                <router-link to="/admin/bots">
                  Bots
                </router-link>
              </li>
              <li>
                <router-link to="/admin/accounts">
                  Accounts
                </router-link>
              </li>
              <li>
                <router-link to="/admin/settings/strategies">
                  Settings
                </router-link>
              </li>
              <li>
                <router-link to="/dashboard">
                  Client Site
                </router-link>
              </li>
            </template>
            <!-- Regular user navigation -->
            <template v-else>
              <li>
                <router-link to="/dashboard">
                  Dashboard
                </router-link>
              </li>
              <li>
                <router-link to="/bots">
                  Bots
                </router-link>
              </li>
              <li>
                <router-link to="/reports">
                  Reports
                </router-link>
              </li>
              <li v-if="canAccessBorrowings">
                <router-link to="/borrowings">
                  Borrowings
                </router-link>
              </li>
              <li>
                <router-link to="/account">
                  Account
                </router-link>
              </li>
            </template>
            <li><a @click="handleLogout">Logout</a></li>
          </ul>
        </div>
      </div>
      
      <!-- Animated FAB for mobile -->
      <transition name="fade-slide">
        <label
          v-if="showFAB"
          for="my-drawer-3"
          class="btn btn-primary btn-circle fixed right-4 bottom-4 lg:hidden z-50 opacity-90 hover:opacity-100 shadow-lg transition-opacity duration-200"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="inline-block w-6 h-6 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </label>
      </transition>
    </div>
    <!-- Sidebar / Drawer -->
    <div class="drawer-side">
      <label
        for="my-drawer-3"
        class="drawer-overlay"
      />
      <div class="menu p-4 w-[300px] h-full bg-base-300 text-base-content">
        <div class="mb-4">
          <BrandComponent />
        </div>
        <ul class="space-y-2">
          <!-- Staff user navigation -->
          <template v-if="isStaff">
            <li>
              <router-link
                to="/admin/bots"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
                    clip-rule="evenodd"
                  />
                </svg>
                Bots
              </router-link>
            </li>
            <li>
              <router-link
                to="/admin/accounts"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clip-rule="evenodd"
                  />
                </svg>
                Accounts
              </router-link>
            </li>
            <li>
              <router-link
                to="/admin/settings/strategies"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                    clip-rule="evenodd"
                  />
                </svg>
                Settings
              </router-link>
            </li>
            <li>
              <router-link
                to="/dashboard"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                  />
                </svg>
                Client Site
              </router-link>
            </li>
          </template>
          <!-- Regular user navigation -->
          <template v-else>
            <li>
              <router-link
                to="/dashboard"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                  />
                </svg>
                Dashboard
              </router-link>
            </li>
            <li>
              <router-link
                to="/bots"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
                    clip-rule="evenodd"
                  />
                </svg>
                Bots
              </router-link>
            </li>
            <li>
              <router-link
                to="/reports"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"
                  />
                </svg>
                Reports
              </router-link>
            </li>
            <li v-if="canAccessBorrowings">
              <router-link
                to="/borrowings"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z"
                    clip-rule="evenodd"
                  />
                </svg>
                Borrowings
              </router-link>
            </li>
            <li>
              <router-link
                to="/account"
                class="flex items-center p-2 rounded-lg hover:bg-base-200"
                @click="closeDrawer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clip-rule="evenodd"
                  />
                </svg>
                Account
              </router-link>
            </li>
          </template>
        </ul>
        <div class="mt-auto pt-4 border-t border-base-200">
          <a
            class="flex items-center p-2 rounded-lg hover:bg-base-200 text-error"
            @click="handleLogout"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                clip-rule="evenodd"
              />
            </svg>
            Logout
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BrandComponent from "@/components/BrandComponent.vue";

export default {
  name: "NavbarComponent",
  components: {
    BrandComponent,
  },
  data() {
    return {
      showFAB: false,
      lastScrollPosition: 0,
      navbarHeight: 0,
    };
  },
  computed: {
    ...mapGetters("theme", ["currentTheme"]),
    ...mapGetters("auth", ["isAuthenticated", "isAdmin", "isStaff", "isSuperAdmin", "hasGrantedAccess"]),
    ...mapGetters("brand", ["allowedAdminPages"]),
    canAccessBorrowings() {
      if (this.isSuperAdmin || this.isStaff) return true;
      return this.allowedAdminPages.includes("borrowings");
    },
  },
  mounted() {
    this.navbarHeight = this.$refs.navbar?.offsetHeight || 0;
    window.addEventListener("scroll", this.onScroll);
    this.checkAuthStatus();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    ...mapActions("auth", ["logout", "checkAuth"]),
    async handleLogout() {
      try {
        await this.logout();
        this.closeDrawer();
        // The router navigation is now handled in the store action
      } catch (error) {
        console.error("Logout failed:", error);
      }
    },
    async checkAuthStatus() {
      await this.checkAuth();
      if (!this.isAuthenticated) {
        this.$router.push("/login");
      }
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      // Show FAB when scrolled past navbar
      this.showFAB = currentScrollPosition > this.navbarHeight;
      this.lastScrollPosition = currentScrollPosition;
    },
    closeDrawer() {
      if (this.$refs.drawerToggle) {
        this.$refs.drawerToggle.checked = false;
      }
    },
  },
};
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* Updated styles */
.drawer-side {
  z-index: 999;
}

.drawer-overlay {
  z-index: 998;
}

.menu {
  z-index: 1000;
}

/* Add smooth transition for hover effects */
.menu a {
  transition: background-color 0.2s ease;
}
</style>
